import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OutlinedButtonComponent } from './outlined-button/outlined-button.component';
import { StatusBadgeComponent } from './status-badge/status-badge.component';
import { PageHeaderComponent } from './page_header/page-header/page-header.component';
import { MatIconModule } from '@angular/material/icon';
import { TableEditButtonComponent } from './table-edit-button/table-edit-button.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { TableDeleteButoonComponent } from './table-delete-butoon/table-delete-button.component';
import { TableQrButtonComponent } from './table-qr-button/table-qr-button.component';
import { PopupCloseButtonComponent } from './popup-close-button/popup-close-button.component';
// import { ExcelExportButtonComponent } from './excel-export-button/excel-export-button.component';
// import { CsvExportButtonComponent } from './csv-export-button/csv-export-button.component';
// import { JsonExportButtonComponent } from './json-export-button/json-export-button.component';
// import { TextExportButtonComponent } from './text-export-button/text-export-button.component';
import { TableCloneButtonComponent } from './table-clone-button/table-clone-button.component';
import { TableViewButtonComponent } from './table-view-button/table-view-button.component';

// Reusable dynamic table & master-detail layout
import { ReusableTableComponent } from './dynamic-table/reusable-table.component';
import { MasterDetailLayoutComponent } from './master-detail-layout/master-detail-layout.component';
import { ReusableReportHeader } from './reusable-report-header/reusable-report-header';
import { FilterPanelComponent } from './filter-panel/filter-panel.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatCardModule } from '@angular/material/card';
import { FlexLayoutModule } from '@angular/flex-layout';


@NgModule({
  declarations: [OutlinedButtonComponent,
    StatusBadgeComponent,
    PageHeaderComponent,
    TableEditButtonComponent,
    TableDeleteButoonComponent,
    TableQrButtonComponent,
    PopupCloseButtonComponent,
    // ExcelExportButtonComponent,
    // CsvExportButtonComponent,
    // JsonExportButtonComponent,
    // TextExportButtonComponent,
    TableCloneButtonComponent,
    TableViewButtonComponent,
    ReusableTableComponent,
    MasterDetailLayoutComponent,
    ],
  exports: [
    OutlinedButtonComponent,
    StatusBadgeComponent,
    PageHeaderComponent,
    TableEditButtonComponent,
    TableDeleteButoonComponent,
    TableQrButtonComponent,
    PopupCloseButtonComponent,
    // ExcelExportButtonComponent,
    // CsvExportButtonComponent,
    // JsonExportButtonComponent,
    // TextExportButtonComponent,
    TableCloneButtonComponent,
    TableViewButtonComponent,
    ReusableTableComponent,
    MasterDetailLayoutComponent,
    ReusableReportHeader,
    FilterPanelComponent,
   ],
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatCardModule,
    FlexLayoutModule,
    ReusableReportHeader,
    FilterPanelComponent,
  ],

})
export class ReusableComponentsModule { }
